import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";
import ButtonLoader from '../../../components/common/buttonLoader/ButtonLoader';

const itemColdefs = [
    {
        field: "drawingNo",
        headerName: "Drawing No",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "itemType",
        headerName: "Item Type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemName",
        headerName: "Item Name",
        minWidth: window.innerWidth * 0.2,
        flex: 1.5,
        filter: true,
    },
    {
        field: "minimumStock",
        headerName: "Minimum Stock",
        minWidth: window.innerWidth * 0.08,
        flex: 1.5,
        filter: true,
    },
    {
        field: "requiredQuantity",
        headerName: "Required Quantity",
        minWidth: window.innerWidth * 0.08,
        flex: 1.5,
        filter: true,
    },
    {
        field: "totalRequiredQuantity",
        headerName: "Total required stock",
        minWidth: window.innerWidth * 0.08,
        flex: 1.5,
        filter: true,
    },
    // {
    //     field: "storeQty",
    //     headerName: "Store qty",
    //     minWidth: window.innerWidth * 0.08,
    //     flex: 1.5,
    //     filter: true,
    // },
]

export const MaterialPlaningPopup = (props) => {
    return (
        <ModalBasic
            id="material-planing"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[20px]'>
                <span className="text-blue text-[16px] font-semibold">Material Planning selection</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp col-span-2'>
                        <label>Select customer</label>
                        <MultiSelectDropdown
                            drpIdentity="Select material"
                            options={props.materialObject.CustomerList}
                            value={props.materialObject.idCustomer ? props.materialObject.CustomerList.find(x => x.value === props.materialObject.idCustomer) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idCustomer")
                            }
                            className={props.validState?.error?.idCustomer !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select work order</label>
                        <MultiSelectDropdown
                            drpIdentity="Select supplier"
                            options={props.materialObject.workOrderList}
                            value={props.materialObject.idWorkOrder ? props.materialObject.workOrderList.find(x => x.value === props.materialObject.idWorkOrder) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idWorkOrder")
                            }
                            className={props.validState?.error?.idWorkOrder !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select product</label>
                        <MultiSelectDropdown
                            drpIdentity="Select inward"
                            options={props.materialObject.productList}
                            value={props.materialObject.idProduct ? props.materialObject.productList.find(x => x.value === props.materialObject.idProduct) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idProduct")
                            }
                            className={props.validState?.error?.idProduct !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Drawing No</label>
                        <TextInput type='text'
                            id='drawingNo' name='drawingNo'
                            value={props.materialObject.drawingNo}
                            //handleChange={(event) => props.handleChange(event, 'drawingNo')}
                            className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Planing quantity</label>
                        <TextInput type='text'
                            id='planingQuantity' name='planingQuantity'
                            value={props.materialObject.planingQuantity}
                            //handleChange={(event) => props.handleChange(event, 'planingQuantity')}
                            className={props.validState?.error?.planingQuantity !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        {props.isLoading ?
                            <ButtonLoader />
                            :
                            <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.click_AddBomData()}>Add bom data</button>
                        }
                        <button className="edit-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.clear()}>Clear</button>
                    </div>
                </div>
                <span className="text-blue text-[16px] font-semibold">Item details</span>
                <div className="process-table h-[50vh]">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.dtMaterialPlanning}
                            columnDefs={itemColdefs}
                            onCellClicked={props.handleCellClickItemList}
                            onGridReady={props.onGridReady}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-2.5'>
                    <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                    {/* <button className="edit-btn btns" >Generate MRS</button> */}
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}